import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9f57962"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["disabled", "placeholder", "value"]
const _hoisted_3 = { class: "PhoneNumber__options" }
const _hoisted_4 = { class: "options__search" }
const _hoisted_5 = { class: "options__content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "option__content" }
const _hoisted_9 = { class: "content__name" }
const _hoisted_10 = { class: "content__code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _directive_maska = _resolveDirective("maska")!

  return (_ctx.state.country_option)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["PhoneNumber", { invalid: _ctx.isInvalid, disabled: _ctx.disabled }]),
        ref: "componentref"
      }, [
        _createElementVNode("div", {
          class: "PhoneNumber__country",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleList && _ctx.toggleList(...args)))
        }, [
          _createElementVNode("img", {
            class: "country__flag",
            src: `/phone/${_ctx.state.country_option.emoji}`,
            alt: "Country Flag"
          }, null, 8, _hoisted_1)
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "default-input",
          disabled: _ctx.disabled,
          placeholder: _ctx.placeholder,
          value: _ctx.value,
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
        }, null, 40, _hoisted_2), [
          [_directive_maska, { mask: _ctx.state.country_option.mask }]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_the_input, {
              disabled: _ctx.disabled,
              class: "search__input",
              placeholder: "Поиск",
              value: _ctx.state.search_param,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.search_param) = $event))
            }, null, 8, ["disabled", "value"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (phone_option) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["options__option", { 'option--active': phone_option.code === _ctx.state.country_option.code }]),
                key: phone_option.code,
                onClick: ($event: any) => (_ctx.setCountryOption(phone_option))
              }, [
                _createElementVNode("img", {
                  class: "option__flag",
                  src: `/phone/${phone_option.emoji}`,
                  alt: "Country Flag"
                }, null, 8, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(phone_option.country), 1),
                  _createElementVNode("div", _hoisted_10, "+" + _toDisplayString(phone_option.phone_code), 1)
                ])
              ], 10, _hoisted_6))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.state.is_list_opened]
        ])
      ], 2))
    : _createCommentVNode("", true)
}